module.exports = __webpack_public_path__ + "static/media/gun-safes-electronic-lock.c9e38708.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/gun-safes-electronic-lock.png
// module id = 1264
// module chunks = 0